import { ReactNode } from 'react';

interface EventContainerProps {
  children: ReactNode;
}

export default function EventContainer({ children }: EventContainerProps) {
  return (
    <div className="max-w-2xl mx-auto px-4 pb-20 pt-4 space-y-4">
      {children}
    </div>
  );
}